module.exports = __webpack_public_path__ + "static/media/heart26.eb0f065b.svg";